export default __webpack_public_path__ + "static/media/pool-blue1.cd38a8b3.png";